import { createFileRoute } from "@tanstack/react-router";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import AdminLawnMowers from "@/pages/admin/AdminLawnMowers";

export const Route = createFileRoute("/admin/lawn-mowers/")({
  component: () => (
    <ProtectedRoute>
      <AdminLawnMowers />
    </ProtectedRoute>
  ),
});
